export default () => ({
  value: "",

  containsContactDetails() {
    return this.value.includes("@") || /[\d -]{6,}/.test(this.value);
  },
});
